import { default as SkipToMain } from './skip-to-main';
export default SkipToMain;
